var CONSTANT = {
  // public
  ADD: 1,
  EDIT: 2,
  DEL: 3,
  APP_CODE: 'dyc',
  // System
  RESP_CODE_SUCCESS1: 0,
  RESP_CODE_SUCCESS: '0000',
  CODE_SUCCESS: '0',
  RESP_CODE_ERR: '8888',
  RESP_CODE_E403: 'E403',
  // 无权访问
  RESP_CODE_AE401: 'AE401',
  // 未登录或Token过期
  // Shop
  STOCK_STATE_1: 33,
  // 有货 现货-下单立即发货
  STOCK_STATE_2: 39,
  // 有货 在途-正在内部配送，预计2-6天到达本仓库
  STOCK_STATE_3: 40,
  // 有货 可配送-下单后从有货仓库配送
  STOCK_STATE_4: 36,
  // 预定
  STOCK_STATE_5: 34,
  // 无货
  SUPPLIER_CODE_JD: 'jd',
  // 京东
  SUPPLIER_CODE_SUNING: 'suning',
  // 苏宁
  SUPPLIER_CODE_ZKH: 'zkh',
  // 振坤行
  SUPPLIER_CODE_GAJ: 'grainger',
  // 固安捷
  SUPPLIER_CODE_DELI: 'deli',
  // 得力
  SUPPLIER_CODE_EHSY: 'ehsy',
  // 西域
  // Manage
  BILLTYPE_01: '01',
  // 收款确认单
  BILLTYPE_02: '02',
  // 付款申请单
  BILLTYPE_03: '03',
  // 物资汇总单
  BILLTYPE_04: '04',
  // 出库汇总单
  BILLTYPE_05: '05',
  // 供应商缴费收款确认单
  BILLTYPE_06: '06',
  // 供应商缴费收入计算单
  BILLTYPE_07: '07',
  // 配送业务收款确认单
  BILLTYPE_08: '08',
  // 供应商缴费冲红收入计算单
  BILLTYPE_09: '09',
  // 手工收款单
  SYSCODE_UCC: 'UCC',
  // 商品中心
  SYSCODE_PEB: 'PEB',
  // 订单中心
  SYSCODE_UMC: 'UMC',
  // 会员中心
  SYSCODE_FSC: 'FSC',
  // 结算中心
  // 中心码表
  SYSCODE_LIST: [{
    keys: 'PEB',
    value: '订单中心'
  }, {
    keys: 'UMC',
    value: '会员中心'
  }, {
    keys: 'UCC',
    value: '商品中心'
  }, {
    keys: 'FSC',
    value: '结算中心'
  }, {
    keys: 'AGR',
    value: '协议中心'
  }, {
    keys: 'USC',
    value: '购物车'
  }],
  // 品牌状态
  BRAND_STATUS: [{
    keys: 1,
    value: '启用'
  }, {
    keys: 0,
    value: '停用'
  }],
  COMMODITYSTATUS_1: '已上架',
  COMMODITYSTATUS_2: '已下架',
  REDISKEY_EMD: 'EMDmCatelog',
  MANAGEMENTSTATE_1: '停业',
  MANAGEMENTSTATE_2: '其他',
  MANAGEMENTSTATE_3: '吊销',
  MANAGEMENTSTATE_4: '在营',
  MANAGEMENTSTATE_4_1: '在营（开业）',
  MANAGEMENTSTATE_5: '注销',
  MANAGEMENTSTATE_6: '迁出',
  SORTORDER_ASC: 'ASC',
  SORTORDER_DESC: 'DESC',
  ORDERSTATUS_00: '00',
  // 未提交
  ORDERSTATUS_01: '01',
  // 已提交
  ORDERSTATUS_02: '02',
  // 已开票
  ORDERSTATUS_03: '03',
  // 已收票
  ORDERSTATUS_07: '07',
  // 退货中
  ORDERSTATUS_08: '08',
  // 售后中
  ORDERSTATUS_98: '98',
  // 挂起
  ORDERSTATUS_99: '99',
  // 作废
  GROUPWAY_NO: 'noSplitGroup',
  // 不分组
  GROUPWAY_PURCHASE: 'purchaseUnitGroup',
  // 采购单位分组
  GROUPWAY_ORDER: 'orderGroup',
  // 订单分组
  REQTYPE_1: 'purOrder',
  CHANNELTYPE_1: '11',
  // 运营单位查询
  CHANNELTYPE_2: '12',
  // 采购单位/供应商结算账户查询
  CHANNELTYPE_3: '13',
  // 调账时查询
  CHANNELTYPE_4: '21',
  // 资金账户查询
  INVOICETYPE_00: '00',
  // 增值税普通发票
  INVOICETYPE_01: '01',
  // 增值税专用发票
  MODIFYINFOTYPE_00: '00',
  // 手机
  MODIFYINFOTYPE_01: '01',
  // 邮箱
  MODIFYINFOTYPE_02: '02',
  // 机构树查询类型
  QUERYTYPE_01: '01',
  // 查询管理机构和下一级机构
  QUERYTYPE_02: '02',
  // 查询管理机构
  ORGTYPE_01: '01',
  ORGTYPE_02: '02',
  ORGTYPE_03: '03',
  CLASSIFICATION_WZ: 'wz',
  // 物资物资分类
  CLASSIFICATION_SG: 'sg',
  // 施工物资分类
  CLASSIFICATION_FW: 'fw',
  // 服务物资分类
  ANNOXCODE_CAPA: 'CAPA',
  ANNOXCODE_MORA: 'MORA',
  MEMCLASSIFY_01: '01',
  MEMCLASSIFY_02: '02',
  FIELDCODE_EVA: 'product_eva',
  FIELDCODE_DESC: 'shop_desc',
  FIELDCODE_SERVICE: 'shop_service',
  FIELDCODE_LOGIS: 'shop_logis',
  FIELDCODE_CONTENT: 'eva_content',
  FIELDCODE_VIDEO: 'product_video',
  FIELDCODE_PIC: 'product_pic',
  FIELDCODE_ANONYMOUS: 'is_anonymous',
  STATUSSTR_1: '有效',
  STATUSSTR_2: '无效',
  STATUSSTR_3: '通过',
  STATUSSTR_4: '待审核',
  IMPORTCOUNT: 30,
  // 导出查询次数
  IMPORTTIME: 500,
  // 导出时间间隔
  ZQPAYAUTHPERMISSION: 'zone:plan:buyer',
  // 专区下单购买权限
  BUYROLE: '002',
  // 内部企业采购权限标识
  YGFLBUYROLE: '022',
  // 员工福利采购权限标识
  EXTBUYROLE: 'tenant:10000:extenterprisecaigouqiyecaigouyuan',
  // 外部企业采购权限标识
  ISSUPPLIERUSER: 'supplier:regist:role',
  // 是否供应商用户
  INITPASSWORD: 'ysyhl9T@',
  // 用户登录初始密码
  PIC_YPE: '.png,.jpg,.jpeg',
  // 图片上传接受的文件类型
  BADIMG: require('@/assets/images/lost2.png'),
  // 破图
  USEHOTSEARCH: false,
  // 是否使用热门搜索 默认false
  USESEARCHHISTORY: true,
  // 是否使用搜索历史 默认false
  USEHOTSUGGEST: true,
  // 是否使用联想词 默认false
  MAXEXPORTNUM: 50000,
  // 最大导出数量
  COOIKETIME: 7200000,
  // cooike有效时长 单位毫秒
  // 电器集市平台类型
  SHOP: 'shop',
  SUPPLIER: 'supplier'
};
export default CONSTANT;